import { axiosClient } from "../../../configs/axiosClient";
import { API } from "../../../configs/endpoints";

export class MyUploadAdapter {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  loader: any;
  onUploaded: (image: { url: string; public_id: string }) => void;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(loader: any, onUploaded: any) {
    this.loader = loader;
    this.onUploaded = onUploaded;
  }

  async upload() {
    const file = await this.loader.file;

    const formData = new FormData();
    formData.append("file", file);

    const { data } = await axiosClient.post(API.product.upload, formData);
    const image = data.images[0];
    this.onUploaded(image);
    return {
      default: image.url,
    };
  }

  abort() {
    console.log("Upload aborted");
  }
}
